import Vue from 'vue'
import { Table } from 'element-ui'

export function Ctrs(param, query) {
  delete Table._Ctor
  Vue.component(
    Table.name,
    function(resolve){
      const bindEvents = Table.methods.bindEvents
      Object.assign(Table.methods,{
        bindEvents() {
          bindEvents.call(this)
          this.bodyWrapper.addEventListener('mousewheel', this.handleBodyMousewheel)
        },
        handleBodyMousewheel(event) {
          const fixedWrapper = this.$refs.fixedWrapper
          if (fixedWrapper) {
            const fixedBodyWrapper = fixedWrapper.querySelector('.el-table__fixed-body-wrapper')
            if (fixedBodyWrapper) {
              event.preventDefault()
              fixedBodyWrapper.scrollBy({ left: event.deltaX, top: event.deltaY })
              this.$refs.bodyWrapper.scrollBy({ left: event.deltaX, top: event.deltaY })
            }
          }
        }
      })
      resolve(Table)
    }
  )
}



// WEBPACK FOOTER //
// ./src/common/js/fscroll.js